import { getApprovalMaxAmount, getApprovalOption } from '~/libs/approval-helper'
import { getOfferKey, normalizeOffer, getAcceptedOffer } from '~/libs/offer-helper'
import { localStorageService } from '~/libs/local-storage.service'

const STORE_KEY = 'latestOptionsHash'

function generateHash(data) {
  if (import.meta.client) {
    return btoa(data)
  } else {
    return (new Buffer(data)).toString('base64')
  }
}

export function getOptionsHash(availableOptions, activeDeal = null, initialChange = null) {
  if (typeof initialChange !== 'function') {
    throw new Error('Approval initial change property is required for calculations')
  }

  const acceptedOffer = activeDeal ? getAcceptedOffer(activeDeal) : null
  const options = acceptedOffer ? [normalizeOffer(acceptedOffer, activeDeal)] : availableOptions
  const stage = acceptedOffer ? 'accepted' : 'comparison'

  if (!options || !options.length) {
    return null
  }

  const normalizedData = options.map((option) => {
    const approvalOption = !option.isStaticOffer ? getApprovalOption(option, initialChange) : {}
    const amount = Number(option.isStaticOffer ? option.amount : getApprovalMaxAmount(option, approvalOption))

    const valuePropositions = (option.valuePropositions || []).map((valueProp) => valueProp.id)

    return {
      id: option.id,
      key: getOfferKey(option),
      amount,
      valuePropositions,
      created: option.created ?? null,
      modified: option.modified ?? null,
    }
  })

  return generateHash(`${stage}:${JSON.stringify(normalizedData)}`)
}

export function getStoredHash() {
  return localStorageService.getItem(STORE_KEY)
}

export function storeHash(hash) {
  if (hash) {
    localStorageService.setItem(STORE_KEY, hash)
  } else {
    localStorage.removeItem(STORE_KEY)
  }
}
